import { render, staticRenderFns } from "./caret.vue?vue&type=template&id=06492310&scoped=true"
import script from "./caret.vue?vue&type=script&lang=js"
export * from "./caret.vue?vue&type=script&lang=js"
import style0 from "./caret.vue?vue&type=style&index=0&id=06492310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06492310",
  null
  
)

export default component.exports